"use client"
import { transitionEase, transitionTime, transitionUpValue } from "./utils"

export const useTransitionUpStyles = (
  $inView: boolean,
  $delay?: number,
  $time?: number,
) => {
  return {
    PointerEvent: "auto",
    opacity: $inView ? 1 : 0,
    transition: `all ${$time ? $time : transitionTime}s ${transitionEase}`,
    /* EGDE-652: the settled state is `none`, not `translateY(0px)`. Any
       transform other than `none` — an identity one included — makes Chrome
       rasterise the element's text with grayscale antialiasing instead of the
       subpixel (ClearType) AA it uses for ordinary text. Every block that
       enters through this helper therefore stayed permanently soft after its
       entrance finished, which on Windows reads as the uneven ink QA filed:
       "the text isn't sharp and uniform. Letters like ל appear with more ink
       than other letters." `none` is the identity matrix, so the transition
       from translateY(50px) still interpolates exactly as before — the
       element simply drops off its composited layer once it lands. */
    transform: $inView ? "none" : `translateY(${transitionUpValue})`,
    ...(typeof $delay === "number" && { transitionDelay: `${$delay}s` }),
  }
}
